import { HarvestingTime } from '@gtpl/shared-models/raw-material-procurement';

export class IndentRequest{
    indentId:number;
    
    constructor(indentId : number){
        this.indentId= indentId;
    }
}
